import authorizationService from '../services/security/authorizationService';
import userActivityService from '../services/security/userActivityService';
import { refreshTokens } from '../services/security/userAuthService';
import { logOutThunk } from '../redux/security/LogOut/logOutThunk';

export const tokenRefreshJob = async () => {
  const cutoffInSeconds = 240;
  if (
    userActivityService.isUserActive() &&
    authorizationService.hasValidToken()
  ) {
    const secondsFromExp = authorizationService.secondsFromExp();
    if (secondsFromExp < cutoffInSeconds) {
      await refreshTokens();
    }
  } else {
    // eslint-disable-next-line no-console
    console.log('calling logout mechanism');
    userActivityService.clearActivityTimer();
    await logOutThunk()();
  }
};
